import ChartSkeleton from '@components/skeletons/ChartSkeleton/ChartSkeleton'

import './DashboardGridSkeleton.css'

const SKELETON_CELLS = [4, 4, 4, 4, 4, 4] as const

export default function DashboardGridSkeleton() {
  return (
    <div id="dashboard-grid-skeleton" aria-hidden="true">
      {SKELETON_CELLS.map((width, index) => (
        <div
          key={index}
          className="dashboard-grid-cell"
          style={{ gridColumn: `span ${width}` }}
        >
          <ChartSkeleton />
        </div>
      ))}
    </div>
  )
}
